import React from 'react';
import { connect } from 'react-redux';
import Translate from 'translate';
import async from 'async';
import ReactTable from 'react-table';

import ConfigurationService from 'services/ConfigurationService';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import TablePagination from "components/HTMLElements/Table/Pagination";

const Table = ( { data, ...rest } ) => (
  <ReactTable className="app-table app-table-white"
              showPageSizeOptions={false}
              data={data || []}
              pageSize={data ? data.length < 5 ? data.length : 5 : 0}
              resizable={false}
              showPaginationBottom={false}
              showPaginationTop
              PaginationComponent={( props ) =>
                <TablePagination {...props} className="bg-app-gray"/>
              }
              {...rest}
  />
);

class Settings extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
    };

    this.getData = this.getData.bind( this );
    this.reloadIncms = this.reloadIncms.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    if( !this.props.isLoading ) this.props.toggleLoading( true );

    ConfigurationService.getConfigurations().then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data && response.data.data.length ) this.setState( { data: response.data.data[0] } )
    } )
  }

  reloadIncms() {
    this.props.toggleLoading( true );

    async.waterfall( [
      cb => {
        ConfigurationService.updateIncms( this.state.data.id )
          .then( ( response ) => cb( response.errors, response.data ) )
      },
    ], ( error, results ) => {
      this.props.toggleLoading( false );

      if( error ) {
        this.props.toggleAlertError( error )
      } else {
        this.setState( { data: results } )
      }
    } )
  }

  render() {
    const { data } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header d-flex justify-content-between">
            <span><Translate id="settings"/></span>
            <button className="btn btn-info" onClick={this.reloadIncms}><Translate id="reloadINCMS"/></button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="contactReasons"/></span>
              </div>
              <div className="box-body">
                <Table data={data.contactReason}
                       columns={[
                         { Header: <Translate id="type"/>, accessor: 'codeType' },
                         { Header: <Translate id="code"/>, accessor: 'codeReason' },
                         { Header: <Translate id="description"/>, accessor: 'descriptionReason' },
                       ]}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="contactTypes"/></span>
              </div>
              <div className="box-body">
                <Table data={data.contactType || []}
                       columns={[
                         { Header: <Translate id="type"/>, accessor: 'codeType' },
                         { Header: <Translate id="description"/>, accessor: 'descriptionType' },
                       ]}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="generalLanguages"/></span>
              </div>
              <div className="box-body">
                <Table data={data.generalLanguage || []}
                       columns={[
                         { Header: <Translate id="name"/>, accessor: 'nameType' },
                       ]}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="rccsGroups"/></span>
              </div>
              <div className="box-body">
                <Table data={data.rccsGroup || []}
                       columns={[
                         { Header: <Translate id="code"/>, accessor: 'codeClass' },
                         { Header: <Translate id="description"/>, accessor: 'descriptionClass' },
                       ]}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="rccsTypes"/></span>
              </div>
              <div className="box-body">
                <Table data={data.rccsType || []}
                       columns={[
                         { Header: <Translate id="code"/>, accessor: 'codeClass' },
                         { Header: <Translate id="idComplaint"/>, accessor: 'idComplaint' },
                         { Header: <Translate id="description"/>, accessor: 'descriptionType' },
                       ]}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="sendServicesTypes"/></span>
              </div>
              <div className="box-body">
                <Table data={data.sendservicesType || []}
                       columns={[
                         { Header: <Translate id="code"/>, accessor: 'codDevelop' },
                         { Header: <Translate id="name"/>, accessor: 'nameType' },
                       ]}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="imsNatures"/></span>
              </div>
              <div className="box-body">
                <Table data={data.imsNature || []}
                       columns={[
                         { Header: <Translate id="id"/>, accessor: 'id' },
                         { Header: <Translate id="name"/>, accessor: 'nature' },
                       ]}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="box box-default">
              <div className="box-header d-flex justify-content-between">
                <span><Translate id="imsScopes"/></span>
              </div>
              <div className="box-body">
                <Table data={data.imsScope || []}
                       columns={[
                         { Header: <Translate id="id"/>, accessor: 'id' },
                         { Header: <Translate id="name"/>, accessor: 'scope' },
                       ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Settings );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/settings/index.js